export default __webpack_public_path__ + "static/media/image_united_states.0dd98fa5.png";